import { combineReducers } from 'redux';
import businessComponents from '../components/business_component_tab/components/business_component_table/redux/businessComponentReducer';

export default combineReducers({
  businessComponents,
  // Todo - Add reducer for project mapping
});
